module.exports = __webpack_public_path__ + "img/i1.ca13e0e4.png";